import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Max time (ms) to show refreshing spinner; prevents UI getting stuck if handler never completes. */
const REFRESH_TIMEOUT_MS = 30_000;

@Injectable({ providedIn: 'root' })
export class PullToRefreshService {
  private handler: (() => void | Promise<void>) | null = null;
  private readonly refreshingSubject = new BehaviorSubject<boolean>(false);

  readonly refreshing$ = this.refreshingSubject.asObservable();

  register(fn: () => void | Promise<void>): void {
    this.handler = fn;
  }

  unregister(): void {
    this.handler = null;
  }

  async triggerRefresh(): Promise<void> {
    const fn = this.handler;
    if (!fn) return;
    this.refreshingSubject.next(true);
    const timeoutId = setTimeout(() => {
      this.refreshingSubject.next(false);
    }, REFRESH_TIMEOUT_MS);
    try {
      const r = fn();
      if (r instanceof Promise) await r;
    } catch {
      // Handler error: still clear refreshing so UI is not stuck
    } finally {
      clearTimeout(timeoutId);
      this.refreshingSubject.next(false);
    }
  }
}
